import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CollectService {

  constructor() { }

  /**
	 * Method generate list to map (array 2D)
	 * @param keyField		field name we want to use it as key
	 * @param lstRecords 	list records that we want to convert to map
	 * @return map<key, object>
   * 
   * e.g. 
   * arrayObject = [
   *                  {id:001, name: 'T1'}, 
   *                  {id:002, name: 'T2'}
   *                ];
   * 
   * => resut = {
   *              001: {id:001, name: 'T1'}, 
   *              002: {id:002, name: 'T2'}
   *            }
	 */
	keyBy(keyField, lstRecords:any[]=[]){

		let mapRecord = {};
		if(lstRecords && lstRecords.length){
			lstRecords.forEach(record => {
				let key = record[keyField];

				if(!mapRecord[key]) mapRecord[key] = {};
				mapRecord[key] = record;

			});
		}
		return mapRecord;
	}

	/**
	 * Method to chunk array
	 * @param arr 			array to chunk
	 * @param chunkSize 	chunk size
	 * @return new array chunked
	 */
	 spliceIntoChunks(arr, chunkSize) {
		const res = [];
		while (arr.length > 0) {
			const chunk = arr.splice(0, chunkSize);
			res.push(chunk);
		}
		return res;
	}
}
